import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CrudService } from '@app/api/api-services/crud.service';
import { BooleanApiModel } from '@app/api/api-models/BooleanApiModel';
import { DefaultTaskApiModel, TasksRequestApiModel, TasksResponseApiModel } from '@app/api/api-models';

@Injectable()
export class DefaultTasksService extends CrudService<DefaultTaskApiModel, number> {
  public apiUrl = 'default-tasks';

  public delete(id: number, removeFromPendingList = false): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/delete/${id}/${removeFromPendingList}`);
  }

  public isInPendingList(id: number): Observable<BooleanApiModel> {
    return this.http.get<BooleanApiModel>(`${this.apiUrl}/is-in-pending-list/${id}`);
  }

  public checkPendingList(
    itemId: number,
    openModal: Function,
    action: Function,
    toasterStart: Function,
    toasterEnd: Function,
    toasterFailed: Function
  ) {
    toasterStart();

    this.isInPendingList(itemId).subscribe({
      next: (response) => {
        toasterEnd();

        if (response.Value) {
          openModal();
          return;
        }

        action();
      },
      error: () => {
        toasterFailed();
      }
    });
  }

  public getTasks(request: TasksRequestApiModel): Observable<TasksResponseApiModel> {
    return this.http.get(`${this.apiUrl}`, { params: request });
  }
}
